import React from "react";
import classNames from "classnames";
import style from "./index.module.scss";
import { Link, useHistory } from "react-router-dom";

interface Props {
    src: string;
    text: string;
}

const Index = ({ src, text }: Props) => {
    const history = useHistory();

    function isMatch(path: string) {
        return history.location.pathname.indexOf(path) !== -1;
    }

    return (
        <Link
            replace
            className={classNames(style.link, {
                [style.current]: isMatch("/" + src)
            })}
            to={src}>
            {text}
        </Link>
    );
};

export default Index;
